import { render } from "./Site.vue?vue&type=template&id=b615d53a"
import script from "./Site.vue?vue&type=script&lang=js"
export * from "./Site.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\ssd_ice\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__